const { h } = require('preact');

function Timestamp(props) {
  let date = new Date(props.value.seconds * 1000);

  return <time dateTime={date.toISOString()}>{date.toLocaleString()}</time>;
}

module.exports = Timestamp;
